import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
import "./index.scss";
import App from "./App";
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@material-ui/core";
import { createTheme } from '@material-ui/core/styles'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

export const theme = createTheme({
    palette: {
       primary: {
          main: "#416a59" // This is an orange looking color
                 },
       secondary: {
          main: "#28BE80" //Another orange-ish color
                  }
             },
//  fontFamily: font // as an aside, highly recommend importing roboto font for Material UI projects! Looks really nice
 });

ReactDOM.render(<ThemeProvider theme={theme}><App /></ThemeProvider>, document.getElementById("root"));

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
